import { gql } from '@apollo/client';
import moment from 'moment';

export const CONSULTAR_HC_PACIENTE = gql`
  query evaluacionSoporteHC($idEvaluacion: Int!) {
    evaluacionSoporteHC(idEvaluacion: $idEvaluacion) {
        idPacienteNavigation{
            idPaciente
            nombre
            apellido
        }
    }
  }
`;

export const CONSULTAR_DELEGACION_PACIENTE = gql`
  query pacienteSoporteHC($idPaciente: Int!) {
    pacienteSoporteHC(idPaciente: $idPaciente) {
        nombre
        apellido
        idDelegacionNavigation {
            descripcion
        }
    }
  }
`;

export const GET_OPCIONES_ACCIONES = gql`
    query accionGestion{
        accionGestion{
            idAccion
            paginaSolapa
            accion
        }
    }
`;

export const OBTENER_BITACORA = gql`
    query bitacora(
        $fechaDesde: CustomDateTime!
        $fechaHasta: CustomDateTime!
        $idAccion: Int
        $descripcion: String!
    ){
        bitacora(
            fechaDesde: $fechaDesde
            fechaHasta: $fechaHasta
            idAccion: $idAccion
            descripcion: $descripcion
        ){
            idBitacora
            idUsuario
            fecha
            descripcion
            precioAnterior
            precioNuevo
            idAccionNavigation {
                paginaSolapa
                accion
            }
            idUsuarioNavigation {
                nombre
                apellido
            }
        }
    }
`;

export const adaptBitacoraArray = (bitacoras) => {
    return bitacoras.map(item => ({
        idBitacora: item.idBitacora,
        idUsuario: item.idUsuario,
        fecha: moment(item.fecha).format('DD/MM/YYYY HH:mm:ss'),
        descripcion: item.descripcion,
        precioAnterior: item.precioAnterior,
        precioNuevo: item.precioNuevo,
        accionCompleta: item.idAccionNavigation?.paginaSolapa + ' - ' + item.idAccionNavigation?.accion,
        nombreCompletoUsuario: item.idUsuarioNavigation?.nombre + ' ' + item.idUsuarioNavigation?.apellido,
    }));
}